import { api } from '../../DefaultService';
import {
  IClassAppCreateProps,
  IClassAppprops,
  IClassAppUpdateParams,
} from './types';

const ENDPOINT = '/v1/integrations/classapp';

export const createClassAppIntegrationAsync = async (
  data: IClassAppCreateProps,
) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllClassAppIntegrationsAsync = async (): Promise<
  IClassAppprops[]
> => {
  return await api
    .get<IClassAppprops[]>(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getClassAppIntegrationByIdAsync = async (
  id: number,
): Promise<IClassAppprops> => {
  return await api
    .get<IClassAppprops>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateClassAppIntegrationAsync = async ({
  id,
  data,
}: IClassAppUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteClassAppIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
